import { useNavigate } from "react-router-dom";
import SvgIcon from "@mui/material/SvgIcon";

function GlobeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-1.71-.31-3.29-1.39-4.22-3.02h2.02c.43.98 1.44 1.72 2.2 2.07v.95zm0-3.11c-.96-.33-2.12-1.17-2.62-2.82h2.62v2.82zm0-4.82H6.68c.1-.89.39-1.7.83-2.4h3.49V12zm0-4.4H8.92C9.87 6.21 10.71 5.48 11 5.18v2.42zm2 12.33v-.95c.76-.35 1.77-1.09 2.2-2.07h2.02c-.93 1.63-2.51 2.71-4.22 3.02zM13 15.64V12h2.62c-.5 1.65-1.66 2.49-2.62 2.82zM13 12V9.6h3.49c.44.7.73 1.51.83 2.4H13zm0-4.4V5.18c.29.3 1.13 1.03 2.08 2.42H13z" />
    </SvgIcon>
  );
}

function Sidebar({ codClients = [], reportsStatus = "idle", onReportsClick }) {
  // Puedes definir handlers más adelante, por ahora los dejamos como comentarios
  const navigate = useNavigate();

  const showReports = reportsStatus === "success";

  const handleReportsClick = () => {
    if (onReportsClick) {
      onReportsClick();
    }
  };
  return (
    <div className="side_nav">
      {/* Acceso Admin */}
      {/* <div className="item_menu">
        <div className="linea">
          <i className="bi bi-building-gear"></i>
          <span className="texto mostrar">Adm. Clientes</span>
        </div>
        <div className="panel_options bajar">
          <span className="item_panel" onClick={() => console.log('Nuevo Cliente')}>Nuevo Cliente</span>
          <span className="item_panel" onClick={() => console.log('Editar Cliente')}>Editar Cliente</span>
        </div>
      </div>
*/}
      {/* Servicios */}
      {/* <div className="item_menu">
        <div className="linea">
          <i className="bi bi-view-list"></i>
          <span className="texto mostrar">Servicios Asignados</span>
        </div>
        <div className="panel_options bajar">
          <span className="item_panel" onClick={() => console.log('Concentrador')}>Concentrador</span>
          <span className="item_panel">FTPUnzip</span>
          <span className="item_panel">IEC870</span>
        </div>
      </div>
*/}
      {/* Informes */}
      {showReports && (
        <div className="item_menu">
          <div
            className="linea"
            onClick={handleReportsClick}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleReportsClick();
              }
            }}
          >
            <GlobeIcon className="report_icon" fontSize="small" />
            <span className="texto mostrar">Informes</span>
          </div>
        </div>
      )}
      {/* ERP */}
      {/*      <div className="item_menu">
        <div className="linea">
          <i className="bi bi-person-workspace"></i>
          <span className="texto mostrar">ERP</span>
        </div>
      </div>
*/}
      {/* Facturación */}
      {/*      <div className="item_menu">
        <div className="linea">
          <i className="bi bi-currency-euro"></i>
          <span className="texto mostrar">Facturación</span>
        </div>
      </div>
*/}
      {/* Informes */}
      {/*     <div className="item_menu">
        <div className="linea">
          <i className="bi bi-file-earmark-binary"></i>
          <span className="texto mostrar">Informes</span>
        </div>
        <div className="panel_options bajar">
          <span className="item_panel">Calidad Energía</span>
          <span className="item_panel">No facturados</span>
          <span className="item_panel">Tensión fuera rango CTs</span>
          <span className="item_panel">Pot. Discrepante</span>
          <span className="item_panel">Bits de Calidad</span>
          <span className="item_panel">Contratos discrepantes</span>
          <span className="item_panel">Cont. mal programados</span>
          <span className="item_panel">Balances y Pérdidas</span>
          <span className="item_panel">Análisis de eventos</span>
        </div>
      </div>
*/}
      {/* Balances y Pérdidas */}
      {/*      <div className="item_menu">
        <div className="linea">
          <i className="bi bi-graph-down-arrow"></i>
          <span className="texto mostrar">Balances & Pérdidas</span>
        </div>
      </div>
*/}
      {/* Partes de trabajo */}
      <div className="item_menu">
        <div className="linea">
          <i className="bi bi-journals"></i>
          <span className="texto mostrar" onClick={() => navigate("/work-orders")}>
            Parte de trabajo
          </span>
        </div>
      </div>

      {/* Gestión de usuarios */}
      <div className="item_menu">
        <div className="linea">
          <i className="bi bi-people"></i>
          <span className="texto mostrar"
            onClick={() => navigate('/user-management')}>Gestión de usuarios</span>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
